module.exports = __webpack_public_path__ + "static/media/user-icon.3a24053a.svg";